module.exports = __webpack_public_path__ + "resources/img/img_application_service_mesimesb_en_m.6dc0a1e117202621585f9af337067b41.png";